import styled from 'styled-components';

import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const SkipToWrapper = styled.section`
  height: 108px;
  @media (min-width: 480px) {
    height: auto;
  }
`;

export const Container = styled.div<{
  isStuck?: boolean;
  isFiltersOpen: boolean;
  isAlpha?: boolean;
  showAlphaElevation?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  position: ${({ isStuck }) => (isStuck ? 'fixed' : 'relative')};
  top: 0;
  left: 0;
  right: 0;
  box-shadow: ${({ isStuck, isAlpha }) =>
    !isAlpha && isStuck
      ? '0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 2px 6px 0px rgba(0, 0, 0, 0.2)'
      : 'unset'};
  background-color: ${({ isStuck, isAlpha }) =>
    !isAlpha && isStuck ? COLORS.white : 'transparent'};
  z-index: 2;
  padding: ${({ isStuck }) => (isStuck ? ' 24px 18px 16px 18px' : '48px 0 0 0')};

  ${({ showAlphaElevation }) =>
    showAlphaElevation &&
    `
    border-radius: 0 0 var(--Sys-BorderRadius-MD, 20px) var(--Sys-BorderRadius-MD, 20px);
    border: 1px solid var(--Sys-Color-Elevation-Level1-Stroke, #37404E);
    background: var(--Sys-Gradient-Elevation-Level1-Fill, linear-gradient(180deg, var(--Sys-Color-Elevation-Level1-Fill-Stops-0, #2C343F) 0%, var(--Sys-Color-Elevation-Level1-Fill-Stops-100, #232A34) 100%));
  `}

  @media ${device.laptop} {
    justify-content: center;
  }

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

export const FilterWrapper = styled.div<{ invisible?: boolean }>`
  top: 25px;
  left: 28px;
  @media ${device.tablet} {
    top: 16px;
    left: 40px;
  }
  @media ${device.laptop} {
    top: 32px;
    left: 60px;
  }
  @media ${device.laptopL} {
    top: 32px;
    left: 96px;
  }
`;

export const FiltersCTA = styled.button<{ invisible?: boolean }>`
  font-family: 'Audi Type';
  cursor: pointer;
  visibility: ${(props) => (props.invisible ? 'hidden' : '')};
  position: sticky;
  top: 0;
  box-shadow: inset 0 0 0 1px ${COLORS.black};
  border: none;
  background-color: transparent;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.black};
  @media ${device.tablet} {
    padding: 16px 24px;
    font-size: 16px;
    line-height: 24px;
    gap: 12px;
  }
`;
